module.exports = __webpack_public_path__ + "assets/img/1f32d2dc00e510d0e5c980cc9a7b2acb.png";